import { SET_VO } from './types';
import { CcEmailOptionGroups } from '../modules/desking/types';
import _, { uniqBy } from 'lodash';

const initialState = {};

export const voReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_VO:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export const voSelectors = {
  selectVODealerEmail: (state: any): string | null => {
    const vo = state.vo;

    if (typeof vo.salesRepresentative?.email === 'string') {
      return vo.salesRepresentative.email;
    }

    if (typeof vo.salesManager?.email === 'string') {
      return vo.salesManager.email;
    }

    return null;
  },
  selectVOEntity: (state: any) => state.vo,
  selectVOId: (state: any) => state.vo.vendorOpportunityId,
  selectRelatedUserEmails: (state: any) => {
    const { vo, creditApp, account } = state;

    const customerContacts = [
      ...(creditApp?.creditApplicationOwner ?? []),
      ...(creditApp?.creditApplicationContacts ?? []),
    ]
      .filter((contact: any) => !!contact?.email)
      .map((contact: any) => ({
        value: contact.email,
        label: [contact.firstName, contact.lastName].filter(Boolean).join(' '),
      }));

    const voContacts = [vo?.salesRepresentative, vo?.salesManager, vo?.financeManager]
      .filter((contact: any) => !!contact?.email && contact.status !== 'blocked')
      .map((contact: any) => ({
        value: contact.email,
        label: [contact.firstName, contact.lastName].filter(Boolean).join(' '),
      }));

    const otherContacts = account.contacts.map((contact: any) => ({
      value: contact.email,
      label: contact.fullName,
    }));

    const all = Array.from(
      new Map([...customerContacts, ...voContacts, ...otherContacts].map(option => [option.value, option])).values()
    );

    return {
      all,
      voContacts,
      otherContacts,
      customerContacts,
      main: {
        value: creditApp?.primaryContact?.email,
        label: [creditApp?.primaryContact?.firstName, creditApp?.primaryContact?.lastName].filter(Boolean).join(' '),
      },
    };
  },
};
